import { createContext } from 'react';

const ChromeStatusContext = createContext(false);

export { ChromeStatusContext };
